import {
  getCatalogItemById,
  hasCatalogPermission,
} from "../../constants/navCatalog";

function makeInstanceId(catalogId) {
  return `${catalogId}__${Date.now().toString(36)}_${Math.random()
    .toString(36)
    .slice(2, 7)}`;
}

function placeWidget(catalogId, x, y, permissions, hasProveedorLimit) {
  const item = getCatalogItemById(catalogId);
  if (
    !item ||
    !hasCatalogPermission(item, permissions, { hasProveedorLimit })
  ) {
    return null;
  }
  const w = item.defaultSize?.w ?? (item.type === "data" ? 4 : 2);
  const h = item.defaultSize?.h ?? (item.type === "data" ? 3 : 2);
  const i = makeInstanceId(catalogId);
  return {
    widget: {
      i,
      catalogId,
      type: item.type,
      widgetKind: item.widgetKind || null,
      route: item.route || null,
    },
    layout: { i, x, y, w, h, minW: 2, minH: 2 },
  };
}

function buildFromSpecs(specs, permissions, hasProveedorLimit = false) {
  const widgets = [];
  const lg = [];
  specs.forEach((spec) => {
    const placed = placeWidget(
      spec.catalogId,
      spec.x,
      spec.y,
      permissions,
      hasProveedorLimit,
    );
    if (!placed) return;
    // Override size if provided
    if (spec.w) placed.layout.w = spec.w;
    if (spec.h) placed.layout.h = spec.h;
    widgets.push(placed.widget);
    lg.push(placed.layout);
  });
  return { widgets, layouts: { lg } };
}

/** Layout por defecto usuario interno. */
export function getInternalDefaultLayout(permissions = {}) {
  return buildFromSpecs(
    [
      { catalogId: "widget-my-tasks", x: 0, y: 0, w: 4, h: 3 },
      { catalogId: "widget-novedades", x: 4, y: 0, w: 4, h: 3 },
      { catalogId: "widget-rfq-quotes", x: 0, y: 3, w: 4, h: 4 },
      { catalogId: "tareas", x: 8, y: 0, w: 2, h: 2 },
      { catalogId: "calendar", x: 10, y: 0, w: 2, h: 2 },
      { catalogId: "clients", x: 8, y: 2, w: 2, h: 2 },
      { catalogId: "general", x: 10, y: 2, w: 2, h: 2 },
    ],
    permissions,
    false,
  );
}

/** Layout por defecto proveedor. */
export function getProveedorDefaultLayout(permissions = {}) {
  return buildFromSpecs(
    [
      { catalogId: "widget-critical-path", x: 0, y: 0, w: 6, h: 3 },
      { catalogId: "cp-gantt", x: 6, y: 0, w: 3, h: 2 },
      { catalogId: "cp-global", x: 9, y: 0, w: 3, h: 2 },
      { catalogId: "cp-notes", x: 6, y: 2, w: 3, h: 2 },
    ],
    permissions,
    true,
  );
}

export function getDefaultDashboardLayout({
  hasProveedorLimit = false,
  permissions = {},
} = {}) {
  if (hasProveedorLimit) {
    const layout = getProveedorDefaultLayout(permissions);
    if (layout.widgets.length > 0) return layout;
  }
  const internal = getInternalDefaultLayout(permissions);
  if (internal.widgets.length > 0) return internal;
  const fallback = getProveedorDefaultLayout(permissions);
  if (fallback.widgets.length > 0) return fallback;
  return { widgets: [], layouts: { lg: [] } };
}

export function createWidgetFromCatalog(catalogItem, existingLayouts = []) {
  const i = makeInstanceId(catalogItem.id);
  const w = catalogItem.defaultSize?.w ?? (catalogItem.type === "data" ? 4 : 2);
  const h = catalogItem.defaultSize?.h ?? (catalogItem.type === "data" ? 3 : 2);
  const maxY = existingLayouts.reduce(
    (acc, l) => Math.max(acc, (l.y || 0) + (l.h || 1)),
    0,
  );
  return {
    widget: {
      i,
      catalogId: catalogItem.id,
      type: catalogItem.type,
      widgetKind: catalogItem.widgetKind || null,
      route: catalogItem.route || null,
    },
    layout: { i, x: 0, y: maxY, w, h, minW: 2, minH: 2 },
  };
}
